import { CommonModule } from '@angular/common';

import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DaButtonModule } from '../da-button';
import { DaLinkModule } from '../da-link';
import { HubspotComponent } from './hubspot.component';
import { HubspotService } from './shared/services/hubspot.service';
import { PrepopulationHandlingService } from './shared/services/prepopulation-handling.service';
import { FormBuilderModule } from '../form-builder/form-builder.module';
import { HubspotTrackingService } from './shared/services/hubspot-tracking.service';

@NgModule({
    declarations: [HubspotComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        FormBuilderModule,
        TranslateModule,
        DaButtonModule,
        DaLinkModule
    ],
    providers: [HubspotService, PrepopulationHandlingService, HubspotTrackingService],
    exports: [HubspotComponent]
})
export class HubspotModule {}
